import { gql } from '@apollo/client';

const NEW_REQUEST_ORDER_FIELDS = gql`
  fragment NewRequestOrderFields on orders {
    id
    storeId
    orderId
    number
    customerName
    customerEmail
    customerPhone
    customerId
    createdAt
    updatedAt
    cancelledAt
    isReorder
    protectionStatus
    protectionTotal
    total
    subtotal
    discountTotal
    currencyCode
    paymentCurrencyCode
    shippingAddress
    store {
      id
      policySettings
      resolvePortalOptions
      incentiveSettings
    }
    claims {
      id
      number
      status
    }
    items {
      id
      orderId
      lineItemId
      title
      imageSrc
      variantId
      sku
      quantity
      price
      total
      subtotal
      tax
      taxTotal
      fulfilledAt
      deliveredAt
      claimItems {
        quantity
        claim {
          status
        }
      }
      returnItems {
        quantity
        returnRecord: return {
          status
        }
      }
    }
  }
`;

export const GET_NEW_REQUEST_ORDERS = gql`
  query NewRequestOrders($storeId: uuid!, $search: String!, $limit: Int = 10) {
    orders(
      where: {
        storeId: { _eq: $storeId }
        _or: [
          { number: { _ilike: $search } }
          { customerEmail: { _ilike: $search } }
          { customerName: { _ilike: $search } }
        ]
      }
      limit: $limit
      order_by: { createdAt: desc }
    ) {
      ...NewRequestOrderFields
    }
  }
  ${NEW_REQUEST_ORDER_FIELDS}
`;

export const GET_NEW_REQUEST_ORDER = gql`
  query NewRequestOrder($storeId: uuid!, $id: uuid!) {
    orders(where: { storeId: { _eq: $storeId }, id: { _eq: $id } }, limit: 1) {
      ...NewRequestOrderFields
    }
  }
  ${NEW_REQUEST_ORDER_FIELDS}
`;

export const GET_NEW_RETURN_POLICY = gql`
  query NewReturnPolicy($input: GetReturnPolicyInput!) {
    getReturnPolicy(input: $input) {
      eligible
      ineligibleReason
      eligibilityWindowDays
      eligibilityStartBasis
      eligibilityDeliveryBufferDays
      shipmentBackDeadlineDays
      resolutionTimingBasis
      resolutionTimingDelayDays
      eligibleFrom
      eligibleUntil
      returnMoney
      items {
        orderItemId
        title
        eligible
        ineligibleReason
        availableQuantity
        maxReturnQuantity
      }
      approvalMode
      approvalReason
      returnReasonPolicyConfigured
      enabledReturnReasons
      evidenceRequirements
      isProtectedOrder
      dynamicFees {
        label
        kind
        type
        value
        appliesTo
      }
      deflectionOffers {
        id
        ruleId
        eligibleOrderItemIds
        type
        offerType
        label
        value
        valueType
      }
      allowedResolutions
      unavailableResolutions {
        resolution
        code
        message
      }
      customerReturnCount
      maxReturnsPerMonth
      flaggedHighVelocity
    }
  }
`;

export const QUOTE_NEW_RETURN_FEES = gql`
  query newReturnFees($input: QuoteReturnFeesInput!) {
    quoteReturnFees(input: $input) {
      orderId
      requestedResolution
      currency
      subtotal
      totalFees
      netAmount
      feeQuoteFingerprint
      dynamicFees {
        label
        kind
        type
        value
        appliesTo
        ruleId
        chargeBasis
        matchedQuantity
        basisAmount
        calculatedAmount
      }
    }
  }
`;

export const QUOTE_NEW_RETURN_SHIPPING_OPTIONS = gql`
  query newReturnShippingOptions($input: QuoteReturnShippingOptionsInput!) {
    quoteReturnShippingOptions(input: $input) {
      storeId
      orderId
      fallbackBehavior
      requiresReturnShippingPhone
      errorCode
      errorMessage
      options {
        id
        source
        courierServiceId
        rateId
        carrier
        service
        displayName
        amount
        currency
        minDeliveryTime
        maxDeliveryTime
        estimatedDeliveryDate
        customerVisible
        sortOrder
        meta
      }
      sources {
        source
        status
        message
      }
    }
  }
`;
